    import NoSavings from '../images/financials/NoSavings.png';
    import aed0to1000 from '../images/financials/aed0to1000.png';
    import aed1000to5000 from '../images/financials/aed1000to5000.png';
    import aed5000to10000 from '../images/financials/aed5000to10000.png';
    import aed10000to20000  from '../images/financials/aed10000to20000.png';
    import aed20000to50000 from '../images/financials/aed20000to50000.png';
    import aed50000 from '../images/financials/aed50000.png';


    export var financial_list=[
    {
        name:"No Savings",
        img:NoSavings,
        cb:"cb74",
        chk_name:"savings"
    },
    {
        name:"0 to 1000 aed",
        img:aed0to1000,
        cb:"cb75",
        chk_name:"savings"
    },
    {
        name:"1000 to 5000 aed",
        img:aed1000to5000,
        cb:"cb76",
        chk_name:"savings"
    },
    {
        name:"5000 to 10,000 aed",
        img:aed5000to10000,
        cb:"cb77",
        chk_name:"savings"
    },
    {
        name:"10,000 to 20,000 aed",
        img:aed10000to20000,
        cb:"cb78",
        chk_name:"savings"
    },
    {
        name:"20,000 to 50,000 aed",
        img:aed20000to50000,
        cb:"cb79",
        chk_name:"savings"
    },
    {
        name:"+50,000 aed",
        img:aed50000,
        cb:"cb80",
        chk_name:"savings"
    }
]